import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient, OpportunityInfo } from '../sdk/sdk';

@Injectable({
  providedIn: 'root',
})
export class OpportunityService {
  private readonly sdk: ApiClient = inject(ApiClient);

  getOpportunity(id: string): Observable<OpportunityInfo> {
    return this.sdk.getOpportunity(id);
  }
}
